// frontend/src/components/canvasser/door/ConversationStep.tsx
import { useEffect, useRef } from 'react'
import { Spinner, VStack } from '@chakra-ui/react'
import type { ResolvedScriptDto } from '../../../types/canvasser'
import type { ScriptAnswers } from '../../../lib/doorDraft'
import type { ScriptLanguage } from '../../../lib/walkPrefs'
import { ConversationEngine } from './conversation/ConversationEngine'

/**
 * [Spec §4.6, Phase 5] The door's script step. An empty or unloadable script never dead-ends: it goes
 * straight to How did it end? with a notice (onNoScript). The script query is offlineFirst, so loading
 * is bounded (network or the offline cache).
 */
export function ConversationStep({ script, isLoading, isError, stateKey, language, onFinish, onEndEarly, onNoScript }: {
  script: ResolvedScriptDto | undefined; isLoading: boolean; isError: boolean; stateKey: string; language: ScriptLanguage
  onFinish: (a: ScriptAnswers) => void; onEndEarly: (a: ScriptAnswers) => void; onNoScript: () => void
}) {
  const unusable = !isLoading && (isError || !script || script.elements.length === 0)
  const onNoScriptRef = useRef(onNoScript)
  onNoScriptRef.current = onNoScript
  useEffect(() => { if (unusable) onNoScriptRef.current() }, [unusable])
  if (isLoading) return <VStack py={16}><Spinner size="lg" color="accent" /></VStack>
  if (unusable || !script) return null
  const s = script
  return (
    <ConversationEngine key={stateKey} elements={s.elements} stateKey={stateKey} language={language}
      onFinish={r => onFinish({ scriptId: s.scriptId, ...r })} onEndEarly={r => onEndEarly({ scriptId: s.scriptId, ...r })} />
  )
}
